import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSoofieUptimeGlobal } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const SoofieUptimeGlobalChartSlice: Slice<any, {}, "SoofieUptimeGlobalChartSlice"> = createSlice({
    name: "SoofieUptimeGlobalChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSoofieUptimeGlobal.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSoofieUptimeGlobal.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSoofieUptimeGlobal.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SoofieUptimeGlobalChartSlice
